import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { AbstractButton, BottomButtonsComponent } from '../bottom-buttons/bottom-buttons.component';

export type InformationTemplateContent = {
    img: string;
    imgMaxWidth?: string;
    fullWidth?: boolean;
    hasTop?: boolean;
    centeredContent?: boolean;
    title?: string;
    text?: string;
    noContentPadding?: boolean;
    buttons?: AbstractButton[];
};

@Component({
    selector: 'web-information-template',
    templateUrl: './information-template.component.html',
    styleUrls: ['./information-template.component.scss'],
    imports: [BottomButtonsComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationTemplateComponent {
    content: InputSignal<InformationTemplateContent> = input({ img: 'default' });
}
